module.exports = __webpack_public_path__ + "img/02822.c412bcf2.svg";